var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.lastProduct
        ? _c(
            "span",
            {
              staticClass: "dropdown-item text-primary",
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.onEdit },
            },
            [
              _c("i", { staticClass: "far fa-vial fa-fw mr-2" }),
              _vm._v("Edit last product\n  "),
            ]
          )
        : _c(
            "span",
            {
              staticClass: "dropdown-item text-primary",
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.addToStrore },
            },
            [
              _c("i", { staticClass: "far fa-vial fa-fw mr-2" }),
              _vm._v("Add to Store\n  "),
            ]
          ),
      _c(
        "b-modal",
        {
          ref: "container",
          attrs: {
            scrollable: "",
            title: `Add to store`,
            "hide-footer": "",
            "modal-class": "modal-fullscreen border-0 rounded-0",
            "content-class": "border-0 rounded-0",
            "body-class": "p-0",
          },
          on: { hidden: _vm.cancel },
        },
        [
          _vm.show
            ? _c("ProductFormView", {
                key: _vm.updatedAt,
                attrs: {
                  defaultProduct: _vm.productData,
                  requireCategory: true,
                  requireStore: true,
                  isModal: true,
                },
                on: { change: _vm.onProductUpdate },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }